<template>
    <li
        v-show="show"
        data-focusable="true"
        @click="sendNameAndInitFocus(name)"
        role="option"
        class="nav__item"
        :aria-selected="active"
        :aria-label="`${updatedTitle} Payment`"
        :class="{
            'nav__item-active': active,
            'nav__item-disabled':
                (processing || backgroundProcessing) && active === false,
        }"
    >
        <button
            type="button"
            aria-hidden="true"
            ref="paymentItem"
            :tabindex="active ? 0 : -1"
        >
            <img
                class="nav__item-icon"
                :src="require('@/assets/icons/' + logo + '.svg')"
                alt=""
                role="presentation"
                :class="name === capitecText ? 'upscale-icon' : 'downscale-icon'"
                loading="lazy"
            />
            <p
                :class="[
                    updatedTitle && updatedTitle.length > 15
                        ? 'nav__item-text-sm'
                        : 'nav__item-text',
                    name === capitecText ? 'capitec-text' : '',
                ]"
            >
                {{ updatedTitle }}
                <span v-if="newPaymentMethods.indexOf(updatedTitle) > -1" class="new-tag">
                    {{ $t("ui.header.new")}}
                </span>
            </p>
        </button>
    </li>
</template>

<script>
import { computed, inject, onMounted, onBeforeUnmount, ref } from "vue";
import { useI18n } from "vue-i18n";

export default {
    name: "NavItem",
    emits: ["toggle-view-payments"],
    computed: {},
    props: {
        title: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        logoName: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        backgroundProcessing: {
            type: Boolean,
            default: false,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            required: true,
        },
        show: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {},
    setup(props, context) {
        const initializeFocus = inject("initializeFocusIndex");
        const paymentItem = ref(null);
        const { t } = useI18n();
        const capitecText = "capitec";

        onMounted(() => {
            addEventListener("on:CurrentFocusIndexChange", handleFocusIndexChange);
            addEventListener(
                "on:ActivateFocusedPaymentOption",
                handleActivateFocus,
            );

            if (props.active === true) {
                initializeFocus(props.index);
            }
        });

        onBeforeUnmount(() => {
            removeEventListener(
                "on:CurrentFocusIndexChange",
                handleFocusIndexChange,
            );
            removeEventListener(
                "on:ActivateFocusedPaymentOption",
                handleActivateFocus,
            );
        });

        function handleActivateFocus({ detail: focusIndex }) {
            if (props.index === focusIndex && props.active !== true) {
                context.emit("toggle-view-payments", props.name);
            }
        }

        function handleFocusIndexChange({ detail: focusIndex }) {
            if (props.index === focusIndex) {
                paymentItem.value.focus();
            }
        }

        function sendNameAndInitFocus(name) {
            context.emit("toggle-view-payments", name);
            initializeFocus(props.index);
        }

        const updatedTitle = computed(() => {
            switch (props.title) {
            case "Card":
                return t("payment.card");

            case "Bank":
                return t("payment.bank");

            case "Bank Transfer":
                return t("payment.banktransfer");

            case "Mobile Money":
                return "Mobile Money";

            case "QR":
                return "mVisa QR";

            default:
                return props.title;
            }
        });

        const newPaymentMethods = ["Flutterwave", "OPay"];

        const logo = computed(() => {
            let newLogo = "";
            switch (props.logoName) {
            case "mobilemoneyghana":
            case "mpesa":
            case "mobilemoneyuganda":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneymalawi":
                newLogo = "mobilemoney";
                break;
            case "mobilemoneyrwanda":
            case "mobilemoneyzambia":
            case "mobilemoneytanzania":
            case "mobilemoneyfranco":
                newLogo = "mobilemoney";
                break;
            default:
                newLogo = props.logoName;
                break;
            }

            if (props.active) {
                return newLogo + "-light";
            }
            return newLogo;
        });
        return {
            logo,
            initializeFocus,
            sendNameAndInitFocus,
            paymentItem,
            updatedTitle,
            newPaymentMethods,
            capitecText,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .cashback {
    display: none;
    @media screen and (min-width: $breakpoint-middle * 1px) {
      display: block;
      color: $white;
      background: $green;
      border-radius: 0.1rem;
      padding: 0.3rem 0.5rem 0.4rem 0.7rem;
      font-size: 0.924899rem;
      line-height: 1rem;
      position: absolute;
      right: 0.1rem;
    }
  }
  .nav__item {
    position: relative;
    background: #fafafa;
    border-bottom: 0.809287px solid #f5eee5;
    padding: 2rem 1.6rem 2rem;
    cursor: default;

    @media screen and (min-width: $breakpoint-middle * 1px) {
      padding: 0;
      background-size: 1rem;
      font-size: 0.8rem;
      line-height: 1.8rem;
      text-align: right;
      // border-bottom: 0.946925px solid $border-color;
      width: 22.8rem;
      background: transparent;
    }

    button {
      border: none;
      display: flex;
      align-items: center;
      // background: transparent;
      // border: 1px solid transparent;
      box-sizing: border-box;

      &::before,
      &::after {
        content: "";
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 0;
        opacity: 0;
        background: transparent;
      }

      &::before {
        background: $primary-color-light;
        transform-origin: top;
        transform: scaleY(0);
      }

      &::after {
        border: 1px solid $primary-color;
      }

      @media screen and (min-width: $breakpoint-middle * 1px) {
        padding: 1.6rem 2rem 1.4rem 5.1rem;
        width: 22.8rem;
      }
      &:focus::after {
        // border-color: $primary-color;
        opacity: 1;
      }
    }

    &-active {
      @media screen and (min-width: $breakpoint-middle * 1px) {
        .nav__item-text {
          color: $primary-color;
        }
        .capitec-text {
          color: #000 !important;
        }
        button::before {
          @media screen and (min-width: 576px) {
            opacity: 1;
            // position: absolute;
            // top: 0;
            // left: 0;
            // width: 100%;
            // height: 100%;
            // content: "";
            // /* transform: translateY(10%); */
            animation: active 0.2s ease-out forwards;
            // background: $primary-color-light;
          }
        }
      }
    }
    &-disabled {
      button {
        background: #f2f2f2;
        cursor: not-allowed;
        opacity: 0.4;
      }
    }
    &-text {
      margin: 0 0 0 1.5rem;
      font-size: 1.5rem;
      font-weight: $font-semi-bold;
      line-height: 1.5rem;
      color: $secondary-text-color;

      &-sm {
        font-size: 1.3rem;
        margin: 0 0 0 1.5rem;
        font-weight: $font-semi-bold;
        line-height: 1.5rem;
        color: $secondary-text-color;
      }
    }
    &-icon {
      /* width: ; */
      /* @include screen (med){ */
      width: 33px;
      /* }  */
    }
  }

  @keyframes active {
    /* from {
    transform: translateX(-300px);
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }
  to {
    border-top-right-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;
  } */
    0% {
      // height: 0%;
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }
  .transfer {
    width: 15px;
  }
  .upscale-icon {
    z-index: 5;
  }
  .downscale-icon {
    z-index: unset;
  }
  .new-tag {
    font-size: 7px;
    line-height: 9px;
    font-weight: 500;
    padding: 2px 4px;
    border-radius: 10px;
    background-color: #FF5805;
    color: #fff;
    margin-right: 4px;
    text-align: center;
    margin-left: 3px;
  }
</style>